// reducers/doctorReducer.js
import { createSlice } from '@reduxjs/toolkit';

const messageSlice = createSlice({
  name: 'doctor',
  initialState: {
    activityList: [],
    totalNumberOfActivity: 0,
    filterActivityListParam: {
      crm_id: '',
      template_id: '',
      dr_name: '',
    },
  },
  reducers: {
    setActivityDetails: (state, action) => {
      state.activityList = action.payload;
    },
    setTotalNumberOfActivity: (state, action) => {
      state.totalNumberOfActivity = action.payload;
    },
    updateFilterActivityListParam: (state, action) => {
      state.filterActivityListParam = action.payload;
    },
  },
});

export const {
  setActivityDetails,
  setTotalNumberOfActivity,
  updateFilterActivityListParam,
} = messageSlice.actions;

export default messageSlice.reducer;
